import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	Container,
	Col,
	Row,
	Button,
	Card,
	Modal,
	ListGroup,
	Form,
	Alert,
	InputGroup,
} from 'react-bootstrap';
import '../assets/css/Recruiter.css';
import '../assets/css/Form.css';
import '../assets/css/Cogen.css';
import { useNavigate, useParams } from 'react-router-dom';
import { Header, Footer } from './Container';
import { ReqPost } from '../config/Requests';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { jobRequest } from '../store/jobOpportunities/async-actions';
import moment from 'moment';
import { Multiselect } from 'multiselect-react-dropdown';
import { ReqGet } from '../config/Requests';
import jsPDF from 'jspdf';
import RemoveDublication from '../helper/removeDublication';
import { toast } from 'react-toastify';
import axios from 'axios';
import { MdInfo } from 'react-icons/md';
const submitBtnMapping = {
	question: {
		title: 'Question',
		text: 'Write your Question below:',
		placeholder: 'Write question here.',
	},
	apply: {
		title: 'Apply',
		text: 'Write comments below if you want.(Optional)',
		placeholder: 'Write your text here.',
	},
	reject: {
		title: 'Reject',
		text: 'Write comments below if you want.(Optional)',
		placeholder: 'Write your text here.',
	},
};

function Job(props) {
	const { id } = useParams();

	// const profile = useSelector(state => state.auth.profile);
	const jobListData = useSelector(state => state.data.jobList);
	// const id = useSelector(state =>
	// 	getIdFromPath(state.router.location.pathname)
	// );
	const error = useSelector(state => state.data.errorMessage);

	const dispatch = useDispatch();

	// const jobList = () => dispatch(jobRequest());

	const [show, setShow] = useState(false);
	const [open, setOpen] = useState(false);
	const [key, setKey] = useState('');
	const [modalValue, setModalValue] = useState('');
	const [data, setData] = useState({});
	const [timerHours, setTimerHours] = useState('00');
	const [timerMinutes, setTimerMinutes] = useState('00');
	const [timerSeconds, setTimerSeconds] = useState('00');
	const [counterDate, setCounterDate] = useState('');
	const [questionsList, setQuestionsList] = useState([]);
	const [expertise, setExpertise] = useState([]);
	const [selecteExpertise, setSelectExpertise] = useState([]);
	const [tools, setTools] = useState([]);
	const [selectTools, setSelectTools] = useState([]);
	const [otherRequirements, setOtherRequirements] = useState([]);
	const [selectOtherRequirements, setSelectOtherRequirements] = useState([]);
	const [profile, setProfile] = useState({});
	const [showTooltip, setShowTooltip] = useState(false);
	const [tagsFormatedData, setTagFormatedData] = useState([]);
	let interval = useRef();
	const timerCallback = counterDate => {
		const realTime = new Date().getTime();
		const timeInMilli = moment(counterDate).valueOf();
		const timeDifference = timeInMilli - realTime;
		const hours = Math.floor(timeDifference / (1000 * 60 * 60));
		const minutes = Math.floor(
			(timeDifference % (1000 * 60 * 60)) / (1000 * 60)
		);
		const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
		if (timeDifference < 0) {
			clearInterval(interval);
		} else {
			setTimerHours(hours);
			setTimerMinutes(minutes);
			setTimerSeconds(seconds);
		}
	};

	useEffect(() => {
		ReqGet(`job/${id}/questions`)
			.then(res => {
				setQuestionsList(res?.data);
			})
			.catch(err => {
				console.log(err.response);
			});
		// get job detail
		ReqGet(`/jobs/${id}`)
			.then(({ data, status }) => {
				setData(data?.data);
				if (status === 200) {
					const index = data.data.members.findIndex(item => {
						return item.id === parseInt(props.profile.user.id);
					});

					// if (index > -1) navigate(`/job-history/${id}`)

					setExpertise(data?.data?.specific_expertise);
					setOtherRequirements(data?.data?.other_requirements);
					setTools(data?.data?.tool);
				}
				const parents = data.data.tags.map(tag => {
					return {
						parent: tag.parent,
						child: [],
					};
				});

				const uniqueArray = Array.from(
					new Set(parents.map(JSON.stringify))
				).map(JSON.parse);

				for (let par = 0; par < uniqueArray.length; par++) {
					for (let child of data.data.tags) {
						if (uniqueArray[par].parent.id === child.parent.id) {
							// delete child.parent;
							uniqueArray[par].child = [...uniqueArray[par]?.child, child];
						}
					}
				}

				setTagFormatedData(uniqueArray);
			})
			.catch(err => {
				console.log(err.response);
			});
	}, []);

	const ref = useRef();
	const navigate = useNavigate();

	const handleClose = () => setOpen(false);

	const postQuestions = () => {
		setKey('question');
		if (!modalValue && key === 'question') {
			alert('please! Enter text');
			return;
		}
		ReqPost(`/job/${id}/question`, { comment: ref.current.value })
			.then(res => {
				if (res.status === 200) {
					toast.success(`Question asked successfully`);

					navigate(`/job/${id}/response`, { params: { key: key } });
				} else if (res?.data?.message) {
					toast.success(res.data.message);
				} else {
					toast.info('Unable to add question');
				}
			})
			// .catch((err) => {
			// })
			.catch(err => {
				toast.error('Unable to ask question');
			});
	};

	const handleApplyModal = () => {
		setOpen(true);
		setKey('apply');
	};

	const handleRejectModal = () => {
		setOpen(true);
		setKey('reject');
	};

	const handleChange = event => {
		setModalValue(event.target.value);
	};

	const history = useNavigate();
	const submitComponent = async () => {
		if (!modalValue && key === 'question') {
			alert('please! Enter text');
			return;
		}
		ReqPost(`/job/${id}/${key}`, {
			applicant_specific_expertise: selecteExpertise,
			applicant_other_requirements: selectOtherRequirements,
			applicant_tool: selectTools,
			comment: key === 'apply' ? '' : ref?.current?.value,
		})
			.then(response => {
				if (response?.data?.status) {
					toast.success(response.data.message);

					// navigate(`/job/${id}/response`, { params: { key: key } });
					navigate('/');
				} else if (response?.data?.message) {
					toast.success(response.data.message);
				}
			})
			.catch(err => {
				toast.error(err?.response?.data?.message);
			});
	};

	const startDate = moment(data.start_date).format('MM-DD-YYYY');
	const endDate = moment(data.end_date).format('MM-DD-YYYY');
	const [dataList, setDataList] = useState([]);
	const [request, setRequest] = useState({
		isInitiated: false,
		isSuccess: false,
		isFailed: false,
		listToggler: false,
	});

	useEffect(() => {
		if (jobListData === undefined || jobListData.length === 0) {
			// jobList();
			ReqGet('jobs', null, {})
				.then(res => {
					if (!res.data.data) {
						// dispatch(jobListRequestFailed('Data not found'));
					} else {
						// dispatch(jobListRequestSuccess(res.data.data));
						return res.data.data;
					}
				})
				.catch(err => {
					dispatch(err.message);
				});
		}
	}, []);

	const [subscribeText, setSubscribeText] = useState('');

	useEffect(() => {
		if (!counterDate || interval.current) {
			return;
		}
		interval.current = setInterval(timerCallback, 1000, counterDate);
	}, [counterDate, timerCallback, interval.current]);
	useEffect(() => {
		ReqGet('profile')
			.then(res => {
				setProfile(res.data);
				setSubscribeText('********');
			})
			.catch(err => {
				console.log(err.message);
			});
		if (!jobListData || !id) {
			return;
		}
		const index = jobListData.findIndex(item => {
			return item.id === parseInt(id);
		});
		if (index === -1) {
			return;
		}

		setData(jobListData[index]);
		setCounterDate(jobListData[index].status_time);
	}, [jobListData, id, data]);

	if (error) {
		return <p>Jobs can't be loaded</p>;
	}
	const generatePDF = () => {
		var doc = new jsPDF('p', 'pt', 'a3');
		let content = `<div style="width: 764px; margin: 40px;"><p style="color:blue;">${data.title}</p>`;
		content += document.querySelector('#content').outerHTML + '</div>';
		console.log('content', content);
		doc.html(content, {
			callback: function (pdf) {
				pdf.save('doc.pdf');
			},
		});
	};
	const addToolFun = e => {
		const { value, checked } = e.target;
		if (!checked) return setSelectTools(selectTools.filter(d1 => d1 != value));
		setSelectTools([...selecteExpertise, e.target.value]);
	};
	const addExpertiesFun = e => {
		const { value, checked } = e.target;
		if (!checked)
			return setSelectExpertise(selecteExpertise.filter(d1 => d1 != value));
		setSelectExpertise([...selecteExpertise, e.target.value]);
	};
	const addOtherRequirementFun = e => {
		const { value, checked } = e.target;
		if (!checked)
			return setSelectOtherRequirements(
				selectOtherRequirements.filter(d1 => d1 != value)
			);
		setSelectOtherRequirements([...selectOtherRequirements, e.target.value]);
	};

	const getIdFromPath = pathName => pathName.split('/').reverse()[0];
	const iconStyle = {
		cursor: 'pointer',
		width: '80%',
		height: '0%',
	};
	const tooltipStyle = {
		position: 'absolute',
		bottom: '100%',
		left: '50%',
		transform: 'translateX(-50%)',
		backgroundColor: '#333',
		color: '#fff',
		padding: '5px',
		borderRadius: '5px',
		width: '742%',
		display: showTooltip ? 'block' : 'none',
	};
	return (
		<Container fluid='true' className='pb-1'>
			<Header type='member' />

			<Container fluid='md'>
				<div
					className='job-detail-wrapper px-5 pt-1 mt-2'
					style={{ border: 20 }}
				>
					<Row className='justify-content-md-left mt-3 mb-3'>
						<Col className='p-0'>
							<Link to='/'>
								<Button variant='outline-primary btn-back-main'>Back</Button>
							</Link>
							<div style={{ display: 'inline', float: 'right' }}>
								<Button
									className='btn-apply'
									hidden={profile.is_subscribed !== 1}
									onClick={handleApplyModal}
								>
									Apply
								</Button>
								<Button
									className='btn-reject'
									hidden={profile.is_subscribed !== 1}
									onClick={handleRejectModal}
								>
									Reject
								</Button>
							</div>
						</Col>
					</Row>
					{data && (
						<Row>
							<Col
								key={data.user_id}
								className='p-0 rounded shadow-sm p-3 mb-5 bg-white'
							>
								{/* <Card className='mt-3 mb-2'>
									<h4 className='p-3'>Job Detail</h4>
									<Card.Body>
										<Card.Text className='text-job-orange'>
											Client ID #:{' '}
											{profile.is_subscribed ? data.user_id : subscribeText}
										</Card.Text>
										<Card.Title className='text-primary small p-1 fw-bold'>
											{data.title}
										</Card.Title>
										<hr />
										<div>
											<Card.Text className='text-job-orange'>
												{data.title} |{' '}
												{data?.requires_travel ? 'Required travel |' : ''}{' '}
												{data.job_location == 'remote' && 'Remote |'}{' '}
												{data.job_location == 'both' && 'Both |'}{' '}
												{data.job_location == 'onsite' && 'On-site |'}{' '}
												{data.job_type == 'fullTime' && 'Full Time'}{' '}
												{data.job_type == 'halfTime' && 'Half Time'}
											</Card.Text>
											<br />
											
											<Card.Text className='text-job-orange'>Job Description</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												<p>
													{profile.is_subscribed
														? data.description
														: subscribeText}
												</p>
											</Card.Text>

											<Card.Text className='text-job-orange'>
												Year Experience
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												<p>{data.year_experience}</p>
											</Card.Text>
											<Card.Text className='text-job-orange'>
												No. of Positions
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.max_applicants}
											</Card.Text>
											<Card.Text className='text-job-orange'>Tags</Card.Text>
										
											<Card.Text className='text-job-normal mb-4 cancel-rmv'>
												<div
													style={{
														display: 'flex',
														maxWidth: '65%',
														marginRight: '10px',
														flexWrap: 'wrap',
														border: '1px solid #e3dada',
														borderRadius: '10px',
													}}
												>
													{data?.tags?.map((d1, index) => {
														return (
															<>
																<div
																	key={index}
																	style={{
																		display: 'flex',
																		backgroundColor: '#0096fb',
																		borderRadius: '10px',
																		fontSize: '13px',
																		color: 'white',
																		padding: '7px',
																		marginTop: '4px',
																		marginBottom: '3px',
																		marginLeft: '4px',
																	}}
																>
																	<div>{d1.display_name}</div>
																</div>
															</>
														);
													})}
												</div>
												
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Job Type
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.job_type == 'fullTime' && 'Full Time'}{' '}
												{data.job_type == 'halfTime' && 'Half Time'}{' '}
												{data.job_type == 'both' && 'Full & half time'}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Job Requesting Manager
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.job_requesting_manager}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Job Location
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.job_location == 'remote' && 'Remote'}{' '}
												{data.job_location == 'both' && 'Both'}{' '}
												{data.job_location == 'onsite' && 'On-site'}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Travel Type
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.travel_type == 'InState' && 'In state'}{' '}
												{data.travel_type == 'Domestic' && 'Domestic'}{' '}
												{data.travel_type == 'International' && 'International'}
											</Card.Text>
										
											<Card.Text className='text-job-orange'>
												Duration of travel
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.travel_duration}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Onsite Meetings
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												<p>
													{data.onsite_meetings == 'no' && 'No'}{' '}
													{data.onsite_meetings == 'yes' && 'Yes'}
												</p>
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Security clearance level
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.security_level == 1 && 'ITAR'}
												{data.security_level == 2 && 'Secret'}{' '}
												{data.security_level == 3 && 'Top Secret'}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Pay rate range
											</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data.start_pay_range}-{data.end_pay_range} Hourly
											</Card.Text>

											<Card.Text className='text-job-orange'>
												Specific Expertise
											</Card.Text>
											{data?.specific_expertise?.map((data, index) => (
												<p key={index} className='text-job-normal mb-1'>
													{data}
												</p>
											))}
											<br />
											<Card.Text className='text-job-orange'>Tools</Card.Text>
											{data?.tool?.map((data, index) => (
												<p key={index} className='text-job-normal mb-1'>
													{data}
												</p>
											))}
											<br />
											<Card.Text className='text-job-orange'>
												Other Requirements
											</Card.Text>
											{data?.other_requirements?.map((data, index) => (
												<p key={index} className='text-job-normal mb-1'>
													{data}
												</p>
											))}
											<br />
											<Card.Text className='text-job-orange'>Dates</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												<span>
													Start Date: &nbsp;
													{startDate}
												</span>
												<br />
												<span>
													End date: &nbsp;
													{endDate}
												</span>
											</Card.Text>
											<Card.Text className='text-job-orange'>State</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data?.state?.name}
											</Card.Text>
											<Card.Text className='text-job-orange'>City</Card.Text>
											<Card.Text className='text-job-normal mb-4'>
												{data?.city}
											</Card.Text>
										</div>
									</Card.Body>
								</Card> */}
								{/* New Code  */}
								<Form style={{ border: '1px solid', marginTop: '12px' }}>
									<Row>
										<Col sm={12}>
											<div
												className={'top-actions bg-label'}
												style={{ borderBottom: ' 1px solid' }}
											>
												<Row style={{ marginLeft: '4px' }}>
													{/* Project id # */}
													<Col
														sm={4}
														style={{ marginTop: '4px', marginBottom: '4px' }}
													>
														<InputGroup controlId='formBasicEmail'>
															<InputGroup.Text
																className='fw-bold text-orange fw-bold ml-2'
																style={{ color: '#e07639' }}
															>
																Project ID #
															</InputGroup.Text>
															<Form.Control
																value={data?.job_id}
																name='job_id'
																rows='1'
															/>
														</InputGroup>
													</Col>
													{/* Job Title */}
													<Col
														sm={7}
														style={{ marginTop: '4px', marginBottom: '4px' }}
													>
														<InputGroup controlId='formBasicEmail'>
															<InputGroup.Text
																className='fw-bold text-orange  ml-2'
																style={{ color: '#e07639' }}
															>
																Job Title:
															</InputGroup.Text>
															<Form.Control
																value={data?.title}
																name='title'
																rows='1'
															/>
														</InputGroup>
													</Col>
												</Row>
											</div>
										</Col>
									</Row>
									{/* Administrative Data */}
									<h4 className={'heading fw-bold p-2 ml-2 rounded'}>
										Administrative Data
									</h4>
									<Row style={{ marginLeft: '4px' }}>
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold fw-bold'>
													Priority Level:
												</InputGroup.Text>
												<Form.Control
													value={
														data?.priority
															? data.priority.charAt(0).toUpperCase() +
															  data.priority.slice(1)
															: ''
													}
													name='priority'
												></Form.Control>
											</InputGroup>
										</Col>

										{/*  Security Clearance*/}
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													Security Clearance Required:
												</InputGroup.Text>
												<Form.Control
													value={
														data?.security_level === '1'
															? 'ITAR'
															: data?.security_level === '2'
															? 'Secret'
															: data?.security_level === '3'
															? 'Top Secret'
															: ''
													}
													name='security_level'
												/>
											</InputGroup>
										</Col>
									</Row>
									{/* No. of Positions */}
									<Col sm={6} style={{ marginTop: '18px', marginLeft: '14px' }}>
										<InputGroup controlId='formBasicEmail'>
											<InputGroup.Text className='fw-bold'>
												No. of Positions:
											</InputGroup.Text>
											<Form.Control
												value={data?.max_applicants}
												name='max_applicants'
												rows='1'
											/>
										</InputGroup>
									</Col>
									{/* Date */}
									<Row
										className='bg-label mt-4'
										style={{
											width: '98.6%',
											marginLeft: '16px',
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											borderTop: ' 1px solid',
										}}
									>
										<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
											{' '}
											Date{' '}
										</Col>
									</Row>
									<Row
										style={{
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											width: '98.6%',
											marginLeft: '16px',
										}}
									>
										<Col sm={12}>
											<Form.Group className='pl-5 mt-4'>
												<Row style={{ marginBottom: '18px' }}>
													<Col xs='auto'>
														{' '}
														<Form.Label style={{ fontWeight: 'bold' }}>
															{' '}
															Start Date:{' '}
														</Form.Label>{' '}
													</Col>
													<Col sm md={4}>
														<Form.Control
															aria-label='Start_date'
															value={data?.start_date}
														></Form.Control>
													</Col>
													<Col md={1} className='ml-4 mt-1'>
														<div
															style={{
																position: 'relative',
																display: 'inline-block',
															}}
														>
															<MdInfo
																style={iconStyle}
																onMouseEnter={() => setShowTooltip(true)}
																onMouseLeave={() => setShowTooltip(false)}
															/>
															<div style={tooltipStyle}>
																Start date must be Greater <br /> than 15 Days
																of Current day
															</div>
														</div>
													</Col>
													<Col xs='auto'>
														{' '}
														<Form.Label style={{ fontWeight: 'bold' }}>
															{' '}
															End Date:{' '}
														</Form.Label>{' '}
													</Col>
													<Col sm md={4}>
														<Form.Control
															aria-label='Start_date'
															value={data?.end_date}
														></Form.Control>
													</Col>
												</Row>
											</Form.Group>
										</Col>
									</Row>
									{/* Job Requesting Manager */}
									<Row
										className='bg-label mt-4'
										style={{
											width: '98.6%',
											marginLeft: '16px',
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											borderTop: ' 1px solid',
										}}
									>
										<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
											{' '}
											Job Requesting Manager{' '}
										</Col>
									</Row>
									<Row
										style={{
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											width: '98.6%',
											marginLeft: '16px',
											marginBottom: '15px',
										}}
									>
										<Col sm={12}>
											<ul className='list-group list-group-flush'>
												<li className='list-group-item fw-bold'>
													{/* {references.map((item, i) => { */}

													<InputGroup
														controlId='formBasicEmail'
														className='mb-4 mt-2'
													>
														<InputGroup.Text className='fw-bold'>
															Full Name:
															<span style={{ color: 'red' }}>*</span>
														</InputGroup.Text>
														<Form.Control
															name='manager_name'
															value={data?.manager_name}
														/>
													</InputGroup>
													<Row>
														<Col sm={6}>
															<InputGroup
																controlId='formBasicEmail'
																className='mb-4'
															>
																<InputGroup.Text className='fw-bold'>
																	Email:
																</InputGroup.Text>
																<Form.Control
																	name='manager_email'
																	value={data?.manager_email}
																/>
															</InputGroup>
														</Col>
														<Col sm={6}>
															<InputGroup
																controlId='formBasicEmail'
																className='mb-2'
															>
																<InputGroup.Text className='fw-bold'>
																	Phone Number:
																</InputGroup.Text>
																<Form.Control
																	name='manager_phone'
																	value={data?.manager_phone}
																/>
															</InputGroup>
														</Col>
													</Row>
												</li>
											</ul>
										</Col>
									</Row>
								</Form>
								{/*Job Profile  */}
								<Form style={{ border: '1px solid', marginTop: '12px' }}>
									<Row>
										<Col sm={12}>
											<div
												className={'top-actions bg-label'}
												style={{ borderBottom: ' 1px solid' }}
											>
												<h4
													className={
														'heading text-orange fw-bold p-2 ml-2 rounded'
													}
												>
													Job Profile
												</h4>
											</div>
										</Col>
									</Row>
									{/* Priority Level */}

									<h4 className={'heading fw-bold p-2 ml-2 rounded'}>
										General Data
									</h4>
									<Col sm={12}>
										<InputGroup
											controlId='formBasicEmail'
											style={{ padding: '10px' }}
										>
											<InputGroup.Text className='fw-bold'>
												Worker Type
											</InputGroup.Text>
											<Form.Control
												value={
													data?.worker_type === '1099-subcontractor'
														? '1099 Subcontractor'
														: data?.worker_type === 'w2-contingent-worker'
														? 'W2 Contingent Worker'
														: data?.worker_type ===
														  'W-2-contingent-to-direct-hire'
														? 'W-2 Contingent to Direct Hire'
														: data?.worker_type === 'direct-hire-only'
														? 'Direct Hire Only'
														: ''
												}
												name=' worker_Type'
											/>
										</InputGroup>
									</Col>
									<Col sm={12} style={{ marginTop: '12px' }}>
										<InputGroup
											controlId='formBasicEmail'
											style={{ padding: '10px' }}
										>
											<InputGroup.Text className='fw-bold'>
												Job Type
											</InputGroup.Text>
											<Form.Control
												value={
													data?.job_type === 'fullTime'
														? 'Full-Time'
														: data?.job_type === 'halfTime'
														? 'Part-Time'
														: data?.job_type === 'both'
														? 'Full-Time and Part-Time'
														: ''
												}
												name='job_type'
											/>
										</InputGroup>
									</Col>
									{/* City and State */}
									<Row
										style={{
											width: '100%',
											marginLeft: '0px',
											marginBottom: '12px',
										}}
									>
										<Col sm={12} style={{ marginBottom: '12px' }}>
											<Row style={{ marginTop: '15px' }}>
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Job Location
														</InputGroup.Text>
														<InputGroup.Text className='fw-bold'>
															State
														</InputGroup.Text>
														<Form.Control
															name='states'
															value={data?.state?.name}
														/>
													</InputGroup>
												</Col>
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															City
														</InputGroup.Text>
														<Form.Control value={data?.city} />
													</InputGroup>
												</Col>
											</Row>
										</Col>
									</Row>
									<Col sm={12}>
										<InputGroup
											controlId='formBasicEmail'
											style={{ padding: '10px' }}
										>
											<InputGroup.Text className='fw-bold'>
												Site Location
											</InputGroup.Text>
											<Form.Control
												value={
													data?.job_location === 'remote'
														? 'Remote'
														: data?.job_location === 'both'
														? 'Both'
														: data?.job_location === 'onsite'
														? 'On-Site'
														: ''
												}
												name='job_type'
											/>
										</InputGroup>
									</Col>
									<Col sm={12} style={{ marginTop: '12px' }}>
										<InputGroup
											controlId='formBasicEmail'
											style={{ padding: '10px' }}
										>
											<InputGroup.Text className='fw-bold'>
												On-Site Meetings Required
											</InputGroup.Text>
											<Form.Control
												value={
													data?.onsite_meetings === 'yes'
														? 'Yes'
														: data?.onsite_meetings === 'no'
														? 'NO'
														: ''
												}
												name='job_type'
											/>
										</InputGroup>
									</Col>
									<Row
										style={{
											width: '100%',
											marginLeft: '0px',
											marginBottom: '12px',
										}}
									>
										<Col sm={12} style={{ marginBottom: '12px' }}>
											<Row style={{ marginTop: '15px' }}>
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Travel Required
														</InputGroup.Text>
														<Form.Control
															value={
																data?.travel_type === 'InState'
																	? 'In-State'
																	: data?.travel_type === 'Domestic'
																	? 'Domestic (US Only)'
																	: data?.travel_type === 'International'
																	? 'International'
																	: ''
															}
														/>
													</InputGroup>
												</Col>
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Duration %
														</InputGroup.Text>
														<Form.Control value={data?.travel_duration} />
													</InputGroup>
												</Col>
											</Row>
										</Col>
									</Row>
									<Row
										style={{
											width: '100%',
											marginLeft: '0px',
											marginBottom: '12px',
										}}
									>
										<Col sm={12} style={{ marginBottom: '12px' }}>
											<Row style={{ marginTop: '15px' }}>
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Destination
														</InputGroup.Text>
														<Form.Control value={data?.destination} />
													</InputGroup>
												</Col>
												<Col sm={6}>
													<InputGroup controlId='formBasicEmail'>
														<InputGroup.Text className='fw-bold'>
															Approx. Duration of Travel
														</InputGroup.Text>
														<Form.Control value={data?.approx_duration} />
													</InputGroup>
												</Col>
											</Row>
										</Col>
									</Row>
								</Form>
								{/* Job Specifications */}
								<Form style={{ border: '1px solid', marginTop: '12px' }}>
									<Row>
										<Col sm={12}>
											<div
												className={'top-actions bg-label'}
												style={{ borderBottom: ' 1px solid' }}
											>
												<h4
													className={
														'heading text-orange fw-bold p-2 ml-2 rounded'
													}
												>
													Job Specifications
												</h4>
											</div>
										</Col>
									</Row>
									<Col
										sm={12}
										style={{
											marginTop: '12px',
											width: '99.3%',
											marginLeft: '4px',
										}}
									>
										<InputGroup
											controlId='formBasicEmail'
											style={{ padding: '10px' }}
										>
											<InputGroup.Text className='fw-bold'>
												Years Experience
											</InputGroup.Text>

											<Form.Control value={data?.year_experience} />
										</InputGroup>
									</Col>
									<Row style={{ marginLeft: '4px', marginTop: '12px' }}>
										<Col sm={6}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													Hourly Pay Rate Range
												</InputGroup.Text>
												<InputGroup.Text className='fw-bold'>
													Low End
												</InputGroup.Text>
												<Form.Control
													value={data?.start_pay_range}
													name='start_pay_range'
													type='text'
												/>
											</InputGroup>
										</Col>
										<Col sm={1}>
											<InputGroup controlId='formBasicEmail'>
												<InputGroup.Text className='fw-bold'>
													To
												</InputGroup.Text>
											</InputGroup>
										</Col>
										<Col sm={5}>
											<InputGroup
												controlId='formBasicEmail'
												style={{ width: '96%' }}
											>
												<InputGroup.Text className='fw-bold'>
													High End
												</InputGroup.Text>
												<Form.Control
													type='text'
													value={data?.end_pay_range}
												/>
											</InputGroup>
										</Col>
									</Row>
									{data && (data.start_pay_range1 || data.end_pay_range1) ? (
										<Row style={{ marginLeft: '4px', marginTop: '12px' }}>
											<Col sm={6}>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className='fw-bold'>
														Hourly Pay Rate Range
													</InputGroup.Text>
													<InputGroup.Text className='fw-bold'>
														Low End
													</InputGroup.Text>
													<Form.Control
														value={data?.start_pay_range1}
														name='start_pay_range1'
														type='text'
													/>
												</InputGroup>
											</Col>
											<Col sm={1}>
												<InputGroup controlId='formBasicEmail'>
													<InputGroup.Text className='fw-bold'>
														To
													</InputGroup.Text>
												</InputGroup>
											</Col>
											<Col sm={5}>
												<InputGroup
													controlId='formBasicEmail'
													style={{ width: '96%' }}
												>
													<span>
														<InputGroup.Text className='fw-bold'>
															High End
														</InputGroup.Text>
													</span>
													<Form.Control
														type='text'
														value={data?.end_pay_range1}
													/>
												</InputGroup>
											</Col>
										</Row>
									) : null}

									{/* Job Description  */}
									<Row
										className='bg-label mt-4'
										style={{
											width: '98.6%',
											marginLeft: '16px',
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											borderTop: ' 1px solid',
										}}
									>
										<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
											{' '}
											Job Description
										</Col>
									</Row>
									<Row
										style={{
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											width: '98.6%',
											marginLeft: '16px',
										}}
									>
										<Col sm={12} className='mt-4 mb-4'>
											<Form.Control
												as='textarea'
												value={data?.description}
												rows='3'
											/>
										</Col>
									</Row>

									{/* Select General & Specific Expertise */}
									<Row
										className='bg-label mt-4'
										style={{
											width: '98.6%',
											marginLeft: '16px',
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											borderTop: ' 1px solid',
										}}
									>
										<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
											{' '}
											Select General & Specific Expertise
										</Col>
									</Row>
									{tagsFormatedData?.map((tag, index) => {
										return (
											<Row
												key={index}
												style={{
													borderLeft: '1px solid',
													borderBottom: ' 1px solid',
													width: '98.6%',
													marginLeft: '16px',
												}}
											>
												{/*  */}
												<Row
													style={{
														marginTop: '15px',
														marginBottom: '15px',
													}}
												>
													<Col md={4}>
														<InputGroup
															controlId='formBasicEmail'
															style={{ marginLeft: '12px' }}
														>
															<InputGroup.Text className='fw-bold'>
																{index === 0
																	? 'Primary General '
																	: 'Secondary General'}
															</InputGroup.Text>
															{/*  Parent  */}
															<Form.Control value={tag.parent.name} />
														</InputGroup>
													</Col>
													{/* 1st child */}

													{tag.child.map((child, index) => {
														return (
															<Col key={index} md={4}>
																<InputGroup controlId='formBasicEmail'>
																	<InputGroup.Text className='fw-bold'>
																		Specific Field {index + 1}
																	</InputGroup.Text>
																	<Form.Control value={child.name} />
																</InputGroup>
															</Col>
														);
													})}
												</Row>
											</Row>
										);
									})}

									{/* Required Skills */}

									<Row
										className='bg-label mt-4'
										style={{
											width: '98.6%',
											marginLeft: '16px',
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											borderTop: ' 1px solid',
										}}
									>
										<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
											{' '}
											Required Skills
										</Col>
									</Row>
									<Row
										style={{
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											width: '98.6%',
											marginLeft: '16px',
										}}
									>
										<Col sm={12} className='mt-2'>
											<ul className='list-group list-group-flush'>
												<li className='list-group-item fw-bold'>
													{data?.specific_expertise?.map((item, i) => {
														return (
															<Form.Group key={i} controlId='formBasicEmail'>
																<Form.Control
																	name='first_name'
																	value={item}
																	as='textarea'
																	rows='1'
																/>
															</Form.Group>
														);
													})}
												</li>
											</ul>
										</Col>
									</Row>
									{/* Recommended Skills */}
									<Row
										className='bg-label mt-4'
										style={{
											width: '98.6%',
											marginLeft: '16px',
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											borderTop: ' 1px solid',
										}}
									>
										<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
											{' '}
											Recommended Skills
										</Col>
									</Row>
									<Row
										style={{
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											width: '98.6%',
											marginLeft: '16px',
										}}
									>
										<Col sm={12} className='mt-2'>
											<ul className='list-group list-group-flush'>
												<li className='list-group-item fw-bold'>
													{data?.other_requirements?.map((item, i) => {
														return (
															<Form.Group key={i} controlId='formBasicEmail'>
																<Form.Control
																	value={item}
																	as='textarea'
																	rows='1'
																/>
															</Form.Group>
														);
													})}
												</li>
											</ul>
										</Col>
									</Row>
									{/* Tool Required/Recommended */}
									<Row
										className='bg-label mt-4'
										style={{
											width: '98.6%',
											marginLeft: '16px',
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											borderTop: ' 1px solid',
										}}
									>
										<Col sm={12} className='fw-bold p-1 ml-3 rounded fw-bold'>
											{' '}
											Tool Required/Recommended
										</Col>
									</Row>
									<Row
										style={{
											borderLeft: '1px solid',
											borderBottom: ' 1px solid',
											width: '98.6%',
											marginLeft: '16px',
											marginBottom: '12px',
										}}
									>
										<Col sm={12} className='mt-2'>
											<ul className='list-group list-group-flush'>
												<li className='list-group-item fw-bold'>
													{data?.tool?.map((item, i) => {
														return (
															<Form.Group key={i} controlId='formBasicEmail'>
																<Form.Control
																	value={item}
																	as='textarea'
																	rows='1'
																/>
															</Form.Group>
														);
													})}
												</li>
											</ul>
											{/* <Row> */}
											{data?.must_own_tools?.map((item, i) => {
												return (
													<Col
														key={i}
														sm={5}
														style={{ marginBottom: '12px', marginLeft: '33px' }}
													>
														<Row style={{ marginTop: '15px' }}>
															<InputGroup controlId='formBasicEmail'>
																<InputGroup.Text className='fw-bold'>
																	Must Own Tools
																</InputGroup.Text>
																<Form.Control value={item} />
															</InputGroup>
														</Row>
													</Col>
												);
											})}
											{data?.client_provides_tools?.map((item, i) => {
												return (
													<Col
														key={i}
														sm={5}
														style={{ marginBottom: '12px', marginLeft: '33px' }}
													>
														<Row style={{ marginTop: '15px' }}>
															<InputGroup controlId='formBasicEmail'>
																<InputGroup.Text className='fw-bold'>
																	Client Provides Tools
																</InputGroup.Text>
																<Form.Control value={item} />
															</InputGroup>
														</Row>
													</Col>
												);
											})}
											{/* </Row> */}
										</Col>
									</Row>
								</Form>
								<Card className='mt-4'>
									<h4 className='p-3 '>Questions Asked</h4>
									<Card.Body>
										<div>
											<div id='content'>
												<h5
													style={{
														color: '#237BDF',
														font: 'normal normal 600 18px/16px Open Sans',
													}}
												>
													Submit Job Questions({questionsList.length})
												</h5>
												<br />
												{data.status === 'QR1' && (
													<h6
														style={{
															color: '#237BDF',
															font: 'normal normal 600 18px/20px Open Sans',
														}}
													>
														Round 1{' '}
													</h6>
												)}
												{data.status === 'QR2' && (
													<h6
														style={{
															color: '#237BDF',
															font: 'normal normal 600 18px/20px Open Sans',
														}}
													>
														Round 2{' '}
													</h6>
												)}

												{questionsList &&
													questionsList.map((item, index) => {
														return (
															<div key={index}>
																<Row style={{ marginLeft: '0px' }}>
																	<p
																		style={{
																			background:
																				'#F1F1F1 0% 0% no-repeat padding-box',
																			font: 'normal normal normal 15px/20px Open Sans',
																			padding: '8px',
																			marginBottom: '0px',
																		}}
																	>
																		<strong style={{ margin: '16px' }}>
																			Question:
																		</strong>
																	</p>
																	<Col style={{ paddingLeft: '0px' }}>
																		<p
																			style={{
																				background:
																					'#F1F1F1 0% 0% no-repeat padding-box',
																				font: 'normal normal normal 15px/20px Open Sans',
																				padding: '8px',
																				marginBottom: '0px',
																			}}
																		>
																			{item.question}
																		</p>
																	</Col>
																</Row>
																<Row style={{ marginLeft: '0px' }}>
																	<p
																		style={{
																			background:
																				'#F1F1F1 0% 0% no-repeat padding-box',
																			font: 'normal normal normal 15px/20px Open Sans',
																			padding: '8px',
																		}}
																	>
																		<strong style={{ margin: '16px' }}>
																			Answer:
																		</strong>
																	</p>
																	<Col style={{ paddingLeft: '0px' }}>
																		<p
																			style={{
																				background:
																					'#F1F1F1 0% 0% no-repeat padding-box',
																				font: 'normal normal normal 15px/20px Open Sans',
																				padding: '8px',
																			}}
																		>
																			{item.answer}
																			{item.document && (
																				<div>
																					<p>
																						The employeer has attached file to
																						this answer
																					</p>
																					<a
																						href={item.document}
																						target='_blank'
																						rel='noopener noreferrer'
																					>
																						Click here to download
																					</a>
																				</div>
																			)}
																		</p>
																	</Col>
																</Row>
															</div>
														);
													})}
												<br />
											</div>
											{questionsList.length > 0 ? (
												<>
													<Button variant='success' onClick={generatePDF}>
														Print Questions
													</Button>
													<br />
													<br />
												</>
											) : null}
											{data.status === 'SLM' ? (
												<p>
													This job was moved to Shortlist phase and no one has
													applied yet.
												</p>
											) : (
												<div>
													<Form.Group controlId='exampleForm.ControlTextarea1'>
														<Form.Control
															disabled={profile.is_subscribed !== 1}
															ref={ref}
															onChange={handleChange}
															as='textarea'
															rows={3}
															placeholder='Ask question here'
															maxlength='10000'
														/>
													</Form.Group>

													<div style={{ display: 'flex',marginTop:'12px' }}>
														<Button
															className='btn-question'
															disabled={
																(data.status === 'QR1' ||
																	data.status === 'QR2') &&
																profile.is_subscribed === 1
																	? false
																	: true
															}
															onClick={postQuestions}
														>
															Ask a Question
														</Button>
														{data.status === 'QR1' || data.status === 'QR2' ? (
															<p className='timer-text'>
																You have {timerHours} hours, {timerMinutes}{' '}
																minutes and {timerSeconds} seconds left to ask
																questions
															</p>
														) : (
															<p
																className='timer-text'
																style={{ color: 'red' }}
															>
																You can't ask questions for {timerHours} hours,{' '}
																{timerMinutes} minutes and {timerSeconds}{' '}
																seconds, unless or untill the employer answers
																all the questions
															</p>
														)}
													</div>
												</div>
											)}

											{request.listToggler === true ? (
												<ListGroup>
													{dataList.length === 0 &&
													request.isSuccess === true ? (
														<ListGroup.Item>
															No Question is asked related to this job
														</ListGroup.Item>
													) : (
														dataList.map((item, i) => {
															return (
																<div key={i}>
																	<h6 className='title'>
																		Questions Asked by Member{' '}
																	</h6>
																	<Container
																		style={{ width: '80%', display: 'block' }}
																	>
																		{item.map((threads, index) => {
																			if (index % 2 === 0) {
																				return (
																					<Col key={index}>
																						<ListGroup.Item>
																							<strong>Anonymous Member:</strong>
																							{threads.body}
																						</ListGroup.Item>
																					</Col>
																				);
																			} else {
																				return (
																					<Col key={index}>
																						<ListGroup.Item>
																							<strong>
																								{data.client.fullname}:
																							</strong>
																							{threads.body}
																						</ListGroup.Item>
																					</Col>
																				);
																			}
																		})}
																	</Container>
																</div>
															);
														})
													)}
												</ListGroup>
											) : null}

											<br />
										</div>
										<Alert
											show={show}
											variant='danger'
											onClose={() => setShow(false)}
											dismissible
										>
											<Alert.Heading>Oh snap! You got an error!</Alert.Heading>
											<p>
												Change this and that and try again. Duis mollis, est non
												commodo luctus, nisi erat porttitor ligula, eget lacinia
												odio sem nec elit. Cras mattis consectetur purus sit
												amet fermentum.
											</p>
										</Alert>
										{open && (
											<Modal
												show={open}
												onHide={handleClose}
												size='md'
												aria-labelledby='contained-modal-title-vcenter'
												centered
											>
												<Modal.Body className='apply-reject-modal rounded'>
													{submitBtnMapping[key].title !== 'Reject' ? (
														<div>
															<h6 className='text-primary'>
																Please Select Given Requirements
															</h6>
															<hr />
															<div className='text-left'>
																<h6>Required Skills</h6>

																{expertise.map((data, index) => (
																	<div key={index}>
																		<input
																			onChange={e => addExpertiesFun(e)}
																			type='checkbox'
																			id={index}
																			name='expertise'
																			value={data}
																		/>
																		<label htmlFor='vehicle1'>
																			&nbsp;&nbsp; {data}
																		</label>
																		<br />
																	</div>
																))}
															</div>
															<br /> <hr />
															<div className='text-left'>
																<h6>Tools</h6>

																{tools.map((data, index) => (
																	<div key={index}>
																		<input
																			onChange={e => addToolFun(e)}
																			type='checkbox'
																			id={index}
																			name='tools'
																			value={data}
																		/>
																		<label htmlFor='vehicle1'>
																			&nbsp;&nbsp; {data}
																		</label>
																		<br />
																	</div>
																))}
															</div>
															<br /> <hr />
															<div className='text-left'>
																<h6>Recommended Skills</h6>

																{otherRequirements.map((data, index) => (
																	<div key={index}>
																		<input
																			onChange={e => addOtherRequirementFun(e)}
																			type='checkbox'
																			id={index}
																			name='otherRequirement'
																			value={data}
																		/>
																		<label htmlFor='vehicle1'>
																			&nbsp;&nbsp; {data}
																		</label>
																		<br />
																	</div>
																))}
															</div>
															<br />
															<hr />
														</div>
													) : (
														''
													)}
													<h6 className='title'>
														Are You Sure Want to {submitBtnMapping[key].title}?
													</h6>
													<button
														className='btn-modal-yes'
														onClick={submitComponent}
													>
														Yes
													</button>
													<br />
													<button
														className='btn-modal-cancel btn-primary'
														onClick={handleClose}
													>
														Cancel
													</button>
												</Modal.Body>
											</Modal>
										)}
									</Card.Body>
								</Card>
							</Col>
						</Row>
					)}
				</div>
			</Container>
			<Footer />
		</Container>
	);
}

export default Job;
